import { createFileRoute, notFound } from '@tanstack/react-router'
import { conversationMessagesQueryOptions, studentConversationsQueryOptions } from '@features/conversations/queries'
import { Conversation } from '@features/conversations/components/Conversation'

export const Route = createFileRoute('/_layout/students/$studentNo/conversations/$conversationId')({
    component: RouteComponent,
    loader: async ({ params, context }) => {
        context.queryClient.ensureQueryData(conversationMessagesQueryOptions({ conversationId: params.conversationId })),
        context.queryClient.ensureQueryData(studentConversationsQueryOptions({ studentNo: params.studentNo }))
        const conversations = await context.queryClient.ensureQueryData(studentConversationsQueryOptions({ studentNo: params.studentNo }))
        const conversation = conversations.find((conversation) => conversation.idConversation === Number(params.conversationId))
        if (!conversation) {
            throw notFound();
        }
        return conversation
    },
    staticData: {
        crumb: {
            dynamicLabel: (match)  => `#${match.params.conversationId}`
        }
    }
})

function RouteComponent() {
    const conversation = Route.useLoaderData()
    const { studentNo } = Route.useParams()

    return (
        <Conversation conversation={conversation} studentNo={studentNo} />
    )
}
